module.exports = __webpack_public_path__ + "static/img/Marinella.1b51b98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Marinella.jpg
// module id = kOIK
// module chunks = 1